import 'css-chunksrc/client/pages/planzoneParametersPage/calendarsHolidays/calendarHolidays/styles.scss';export default {
  "row": "_row_j5nzb_1",
  "tile": "_tile_j5nzb_16",
  "tileIcon": "_tileIcon_j5nzb_27",
  "main": "_main_j5nzb_33",
  "name": "_name_j5nzb_38",
  "meta": "_meta_j5nzb_47",
  "defaultPill": "_defaultPill_j5nzb_53",
  "actions": "_actions_j5nzb_65",
  "iconBtn": "_iconBtn_j5nzb_77",
  "icon": "_icon_j5nzb_77",
  "edit": "_edit_j5nzb_99",
  "remove": "_remove_j5nzb_106"
};